import * as Types from '../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type UserSuggestionsQueryVariables = {
  filter: Types.Scalars['String']
};


export type UserSuggestionsQuery = (
  { __typename?: 'Query' }
  & { users: Array<Types.Maybe<(
    { __typename?: 'User' }
    & Pick<Types.User, '_id' | 'name' | 'email' | 'department' | 'roles' | 'external' | 'extension' | 'companyName'>
  )>> }
);

export type UserByIdQueryVariables = {
  id: Types.Scalars['String']
};


export type UserByIdQuery = (
  { __typename?: 'Query' }
  & { user: Types.Maybe<(
    { __typename?: 'User' }
    & Pick<Types.User, '_id' | 'name' | 'email' | 'department' | 'roles' | 'external' | 'extension' | 'companyName'>
  )> }
);

export const UserSuggestionsDocument = gql`
    query UserSuggestions($filter: String!) {
  users(filter: $filter) {
    _id
    name
    email
    department
    roles
    external
    extension
    companyName
  }
}
    `;

    export function useUserSuggestionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserSuggestionsQuery, UserSuggestionsQueryVariables>) {
      return ApolloReactHooks.useQuery<UserSuggestionsQuery, UserSuggestionsQueryVariables>(UserSuggestionsDocument, baseOptions);
    };
      export function useUserSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserSuggestionsQuery, UserSuggestionsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<UserSuggestionsQuery, UserSuggestionsQueryVariables>(UserSuggestionsDocument, baseOptions);
      };
      
export type UserSuggestionsQueryHookResult = ReturnType<typeof useUserSuggestionsQuery>;
export type UserSuggestionsQueryResult = ApolloReactCommon.QueryResult<UserSuggestionsQuery, UserSuggestionsQueryVariables>;
export const UserByIdDocument = gql`
    query userById($id: String!) {
  user(id: $id) {
    _id
    name
    email
    department
    roles
    external
    extension
    companyName
  }
}
    `;

    export function useUserByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
      return ApolloReactHooks.useQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, baseOptions);
    };
      export function useUserByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, baseOptions);
      };
      
export type UserByIdQueryHookResult = ReturnType<typeof useUserByIdQuery>;
export type UserByIdQueryResult = ApolloReactCommon.QueryResult<UserByIdQuery, UserByIdQueryVariables>;